import type { RefObject } from 'react';

export const scrollContainerId = 'pg-scrollContainerId';

type Direction = 'top';

interface Props {
  offset: number;
  behavior: ScrollBehavior;
  block?: ScrollLogicalPosition;
  inline?: ScrollLogicalPosition;
}
const defaultOptions: Props = {
  offset: 0,
  behavior: 'smooth',
};

const scrollTo = (ref: RefObject<HTMLElement> | Direction | undefined, options: Partial<Props> = {}) => {
  if (!ref) return;

  const { offset, behavior } = { ...defaultOptions, ...options };

  const top = ref === 'top' ? 0 : (ref.current?.getBoundingClientRect()?.top ?? 0) + window.scrollY - offset;

  window?.scrollTo({ top, behavior });
};

const scrollIntoView = (ref: RefObject<HTMLElement> | undefined, options: Partial<Props> = {}) => {
  if (!ref) return;

  ref.current?.scrollIntoView(options);
};

const useScrollTo = () => {
  return {
    actions: {
      scrollTo,
      scrollIntoView,
    },
  };
};

export default useScrollTo;
